/*
 Registers a global error hook that displays a generic modal dialog when an XHR error occurs.
 */

define(['jquery',
        'core/urls',
        'core/loading-animation'],
    function($, urls, loading_animation) {

        // required by the ajaxError() function to detect errors caused by page loads
        var isPageBeingRefreshed = false;
        window.onbeforeunload = function() {
            isPageBeingRefreshed = true;
        };

        function showSentryReportDialog() {
            Sentry.showReportDialog({
                user: window.globals.user
            });
        }

        function displayErrorDialog() {
            if(loading_animation) loading_animation.complete();
            // $('#xhr-failure-reload-button').click(function(evt) {
            //     window.location.reload(true);
            // });
            // $('#xhr-failure-box').modal('show');
        }

        $(document).ajaxError(function(event, jqXHR, ajaxSettings, thrownError) {
            // if the XHR is simply aborted due to a page (re)load, we'll ignore this (see http://stackoverflow.com/a/12030744/6278)
            if (isPageBeingRefreshed) {
                return; // not an error
            }

            // if we're getting a 403 (Forbidden), send the user to the login page
            if (jqXHR.status === 403) {
                window.location.href = urls['account:auth-login']() + '?next=' + window.location.pathname;
                return;
            }

            // send this to Sentry as well
            if (window.Sentry) {   // if Sentry hasn't been enabled for this environment, we'll just show the old error modal below
                var textualHttpResponseReason = thrownError || jqXHR.statusText;   // this is taken straight from old Sentry documentation
                Sentry.configureScope(function(scope) {
                    scope.setExtra('type', ajaxSettings.type);
                    scope.setExtra('url', ajaxSettings.url);
                    scope.setExtra('data', ajaxSettings.data);
                    scope.setExtra('status', jqXHR.status);
                    scope.setExtra('error', textualHttpResponseReason);
                    scope.setExtra('response', jqXHR.responseText ? jqXHR.responseText.substring(0, 100) : 'n/a');
                });
                Sentry.captureMessage(   // unfortunately, there's no exception and no stack trace to log here :( -- that's why we're using captureMessage(), not captureException()!
                    'jQuery ajaxError: status ' + jqXHR.status + ', reason: ' + textualHttpResponseReason,
                    'warning'   // could certainly also make the case for turning this into an error, but for now it's a warning because most of the time this is the warning to an accompanying error on the backend
                );

                // show the sentry error dialog
                showSentryReportDialog();

                // Close all open dialogs, to reduce the chance of the Sentry report dialog appearing 'below' an open modal.
                // However, somewhat annoyingly, we often use jQuery's 'fade' animation, which (by default) takes 400ms and
                // we cannot hide them until the animation has completed and they are 'shown'. Therefore the awkward
                // setTimeout() here. There's probably a cleaner way to do this, but I can't think of one right now.
                setTimeout(function() {
                    $('.modal').modal('hide');
                }, 500);
            } else {
                displayErrorDialog();
            }
        });

        return {
            showErrorDialog: displayErrorDialog,
            showSentryReportDialog: showSentryReportDialog
        }
    }
);
